// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1hZ2S","notes":"Notes_notes__3mg4o","note":"Notes_note__jMQl6","markdown":"Notes_markdown__pVQO5"};